import renderWhenVisible from './render-when-visible'

export default renderWhenVisible
